import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ProductionRoutingService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves the production routing comp for the given comp keyno and routing keyno.
     *
     * @datatask 3884
     * @datataskName sp_ws_p2_productionroutingcomp_get
     * @param params for the comp to retreive.
     * @returns promise containing the production routing comp.
     */
    public async getProductionRoutingComp(params: ProductionRoutingCompParams): Promise<ProductionRoutingCompGet> {
        return (await this.datatask.Post(3884, params))[0];
    }

    /**
     * Saves the production routing comp.
     *
     * @datatask 3885
     * @datataskName sp_ws_p2_productionroutingcomp_save
     * @param params for the comp with changes to save.
     * @returns promise containing errorocde and message.
     */
    public async saveProductionRoutingComp(params: ProductionRoutingCompGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3885, params))[0];
    }

    /**
     * Deletes the production routing comp.
     *
     * @datatask 3886
     * @datataskName sp_ws_p2_productionroutingcomp_delete
     * @param params for the comp with changes to delete.
     * @returns promise containing errorocde and message.
     */
    public async deleteProductionRoutingComp(params: ProductionRoutingCompGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3886, params))[0];
    }

    /**
     * Retrieves list of production routings.
     *
     * @datatask 3658
     * @datataskName sp_ws_p2_productionrouting_select_list
     * @returns promise containing list of production routings.
     */
    public getProductionRoutings(): Promise<ProductionRoutingItem[]> {
        return this.datatask.Post(3658);
    }

    /**
     * Retrieves list of production routing work for the given production routing keyno.
     *
     * @datatask 3877
     * @datataskName sp_ws_p2_productionroutingwork_option_list
     * @param param the production routing keyno to retrieve works for.
     * @returns promise containing list of works for the given production routing keyno.
     */
    public getProductionRoutingWorks(params: { productionrouting_keyno: string }): Promise<ProductionRoutingWorkItem[]> {
        return this.datatask.Post(3877, params);
    }
}

export interface ProductionRoutingWorkItem {
    productionroutingwork_keyno: string;
    operation_order: string;
    operation_id: string;
    operation_name: string;
    is_selected: '1' | '0' | boolean;
}

export interface ProductionRoutingItem {
    productionrouting_keyno: string;
    productionroutinglang_name: string;
}

export interface ProductionRoutingCompParams {
    productionroutingwork_keyno: string;
    productionrouting_keyno: string;
}

export interface ProductionRoutingCompGet {
    productionroutingwork_keyno: string;
    productionrouting_keyno: string;
    prod_id: string;
    prod_name: string;
    quantity_from: string;
    quantity: string | number;
    fixed_cost_locval_pr_sku: string | number;
    optional: '1' | '0';
    comp_lineno: string | number;
    webpage_heading: string;
    operation_id_related_to: string;
}
